import React, { useEffect, useContext } from "react";
import styled from "styled-components";
import ImgSlider from "./ImgSlider";
import Movies from "./Movies";
import Viewers from "./Viewers";
import * as firebase from "firebase/app";
import Details from "./DataBase";
import Detail from "./Detail";
import axios from "axios";
import authContext from "../store/authContext";

import { useState } from "react";

const Home = () => {
	const [mdetails, setMdetails] = useState([]);
	const [count, setCount] = useState(1);
	const [clicked, setClicked] = useState(false);
	const aapi = process.env.REACT_APP_API_KEY;
	console.log("env", process.env.REACT_APP_API_KEY);
	const tmdb_api = "0bcafd5b459497ec53d81e9fc940f86d";
	const ctx = useContext(authContext);
	console.log(ctx.inputItem);
	useEffect(() => {
		// console.log(window.innerHeight());
		console.log();
		count !== 4 &&
			setCount((pre) => {
				return pre + 1;
			});
		axios
			.get(
				`https://api.themoviedb.org/3/trending/all/day?api_key=${tmdb_api}&page=${count}`
			)
			.then((res) => {
				// console.log("res", res);
				setMdetails((prev) => {
					return [...prev, ...res.data.results];
				});
			});
	}, [count]);
	return (
		<Container>
			<ImgSlider />
			<Viewers />
			<Movies lt={mdetails} />
		</Container>
	);
};

export default Home;

const Container = styled.main`
	overflow-x: hidden;
	min-height: calc(100vh - 60px);
	padding: 0 calc(3.5vw + 5px);
	position: relative;
	background-color: #0c111b;
	&:before {
		// background: url("./images/home-background.png") center center / cover
		// 	no-repeat fixed;
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: -1;
	}
`;
